import axios from 'axios'

export const removeUserAccesses = accessIds => {
    var url = `${window.MYQLOCX_API}/subject/admin/messagegroups/user-accesses/${accessIds.join(',')}`

    return axios.delete(url).then(t => {
        return t.data
    }).catch(e => {
        console.log(e)
    })
}

export const removeMessageGroups = accessIds => {
    var url = `${window.MYQLOCX_API}/subject/admin/messagegroups/${accessIds.join(',')}`

    return axios.delete(url).then(t => {
        return t.data
    }).catch(e => {
        console.log(e)
    })
}

export const removeCompanyAccesses = accessIds => {
    var url = `${window.MYQLOCX_API}/subject/admin/messagegroups/company-accesses/${accessIds.join(',')}`

    return axios.delete(url).then(t => {
        return t.data
    }).catch(e => {
        console.log(e)
    })
}

export const createOrUpdateUsersGroup = (lockId, customerIds, groupInfo) => {
    var url = `${window.MYQLOCX_API}/subject/admin/messagegroups/users`

    return axios.post(url, { lockId, customerIds, groupInfo }).then(t => {
        return t.data
    }).catch(e => {
        console.log(e)
    })
}

export const createCompanyGroup = (body) => {
    var url = `${window.MYQLOCX_API}/subject/admin/messagegroups/company`

    return axios.post(url, body).then(t => {
        return t.data
    }).catch(e => {
        console.log(e)
    })
}


export const getMessageGroups = (lockId) => {
    var url = `${window.MYQLOCX_API}/subject/admin/messagegroups/lock/${lockId}`

    return axios.get(url).then(t => {
        return t.data
    }).catch(e => {
        console.log(e)
    })
}